import React from "react";

export default function HomepageVisibilityToggle({ visible, toggle }) {
  return (
    <span className="form-check form-switch p-0 d-inline me-1">
      <input className="form-check-input m-0 p-0 cursor-pointer" type="checkbox" checked={visible} onChange={toggle} />
    </span>
  );
}
